import { useBackendApi } from "./backendApi";
import { DownloadFileDto } from "./fileService";


export function useDownloadLinkService() {
  const nekstApi = useBackendApi();

  const getFileDownloadLinkByCode = async (code: string) => {
    return await nekstApi.get(`/files/download/${code}`) as DownloadFileDto;
  };

  const getFileDownloadLinkById = async (id: number) => {
    return await nekstApi.get(`/files/${id}/downloadlink`) as DownloadFileDto;
  }

  return {
    getFileDownloadLinkByCode,
    getFileDownloadLinkById
  };
}
